import React from "react";
import { Link } from "react-router-dom";
import ForgotPasswordForm from "../../components/auth/ForgotPasswordForm";
import "./AuthPages.css";

export default function ForgotPasswordPage() {
  return (
    <div className="auth-shell">
      <section className="auth-main">
        <div className="auth-container">
          <div className="auth-header">
            <h1>Forgot Password</h1>
            <p>Enter your email and we'll send you a reset link.</p>
          </div>
          <ForgotPasswordForm />
          <div className="auth-links">
            <Link to="/login">Back to login</Link>
          </div>
          <p className="auth-copyright">
            © 2026 DecisionFlow. All rights reserved.
          </p>
        </div>
      </section>
      <aside className="auth-side">
        <h2>Password Recovery</h2>
        <p>
          Click the link in your email to set a new password. If you're on an
          air-gapped system, ask your administrator to reset your password
          directly.
        </p>
      </aside>
    </div>
  );
}
